import React from "react";
import "./nav.scss";
import { NavLink, Link, withRouter } from "react-router-dom";
import { signout, isAuthenticated } from "../auth";

const Navbar = ({ history }) => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img
              src="https://img.icons8.com/bubbles/50/000000/home.png"
              alt="logo"
            />
            student shelter
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div className="navbar-nav ml-auto">
              <NavLink
                exact
                activeClassName="navlink"
                className="nav-link mr-3"
                to="/"
              >
                Home
              </NavLink>

              {!isAuthenticated() && (
                <NavLink
                  activeClassName="navlink"
                  className="nav-link"
                  to="/signin"
                >
                  Login
                </NavLink>
              )}

              {isAuthenticated() && isAuthenticated().user.role === 0 && (
                <span className="nav-item mr-3">
                  <li className="nav-item dropdown ">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        width="30"
                        height="30"
                        className="rounded-circle "
                        style={{ border: "1.2px solid #d9d9d9" }}
                        src={isAuthenticated().user.avatar}
                        alt="profile"
                      />
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      <li>
                        <NavLink
                          exact
                          className="dropdown-item"
                          to={`/mybooking/${isAuthenticated().user._id}`}
                        >
                          My Booking
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          exact
                          className="dropdown-item"
                          to="/user/dashboard"
                        >
                          Profile
                        </NavLink>
                      </li>
                      <li>
                        <span
                          style={{ cursor: "pointer", color: "#70709D" }}
                          className="dropdown-item"
                          onClick={() =>
                            signout(() => {
                              history.push("/");
                            })
                          }
                        >
                          Signout
                        </span>
                      </li>
                    </ul>
                  </li>
                </span>
              )}
              {isAuthenticated() && isAuthenticated().user.role === 1 && (
                <>
                  <li className="nav-item">
                    <NavLink
                      exact
                      activeClassName="navlink"
                      className="nav-link mr-2"
                      to="/admin/dashboard"
                    >
                      Dashboard
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <span
                      style={{ cursor: "pointer", color: "#70709D" }}
                      className="nav-link mr-2"
                      onClick={() =>
                        signout(() => {
                          history.push("/");
                        })
                      }
                    >
                      Signout
                    </span>
                  </li>
                </>
              )}

              <li className="nav-item dropdown mr-5">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  Help
                </a>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a className="dropdown-item" href="#">
                      Help Center
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </li>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default withRouter(Navbar);
